import type { SignalSource } from "app/pages/sales-intelligence/domain/signals/types/signal";
import { getIconForSignalType } from "app/pages/sales-intelligence/modules/signals/constants/signalTypeIcons";

import type SignalsService from "../../services/SignalsService";
import type SignalTypeWithIcon from "../SignalTypeWithIcon";

import type SignalTypesListViewModel from "./SignalTypesListViewModel";

type FactoryDeps = {
    signalsService: SignalsService;
    signalSource: SignalSource;
};

export default function createSignalTypesListViewModel(deps: FactoryDeps): Readonly<SignalTypesListViewModel> {
    const { signalsService, signalSource } = deps;

    /**
     * Listed per source, so a type the account cannot use *here* drops out even when it is entitled
     * elsewhere -- that is the whole of what the Signals API lists used to do by hand.
     *
     * Locked types are kept so the management modal can gate them with an explanatory banner rather than
     * hiding them (`SignalsList`). `initiallySelectedType` picks from the entitled ones, and
     * `signal-modal/factory` vetoes a locked `preferredSignalType`, so no create flow can open on one.
     */
    return {
        get initiallySelectedType() {
            return signalsService.availableSignalTypes[0];
        },
        get signalSource(): SignalSource {
            return signalSource;
        },
        get signalTypes(): readonly SignalTypeWithIcon[] {
            return signalsService.getManagementSignalTypes(signalSource).map<SignalTypeWithIcon>((type) => ({
                type,
                icon: getIconForSignalType(type),
            }));
        },
    };
}
